<ng-container *ngIf="showFunds">
    <app-assets-table [assets]="policyFunds" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly" (emitFunds)="readFunds($event)"></app-assets-table>
</ng-container>
<div class="d-flex justify-content-start mt-4">
    <h6>Totale importo disinvestimenti: <span class="status-ko">{{ totalDisinvestmentAmount | currency:'EUR' }}</span></h6>
</div>